import { useFeatureFlag, type FeatureFlag } from '../use-feature-flag';
import { useEffect } from 'react';

interface UseAbTestLogicArgs {
  onFeatureOn: () => void;
  onFeatureOff: () => void;
  featureName: FeatureFlag;
}

export const useAbTestLogic = ({
  onFeatureOn,
  onFeatureOff,
  featureName,
}: UseAbTestLogicArgs) => {
  const [, { featureFlagValue }] = useFeatureFlag(featureName);

  useEffect(() => {
    if (featureFlagValue === 'on') {
      onFeatureOn();
    } else if (featureFlagValue === 'off') {
      onFeatureOff();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureFlagValue]);
};
